<template>
    <div>
        <!---->
        <el-form :model="formData" :rules="rules" ref="formData" label-width="120px" size="mini" :inline="true">
            <el-form-item class="form-title" prop="i_id" label="id" style="width: 350px">
                <div class="mrA">{{formData.i_id}}</div>
            </el-form-item>
            <!--v-model="formData.typeList"-->
            <el-form-item prop="typeList" label="客商类型" style="width: 710px" >
                <el-checkbox-group :value="formData.typeList"
                                   @input="val => $set(formData, 'typeList', val)"  :key="checkkey" @change="changetype" v-if="canEdit">
                    <el-checkbox :label="1" :disabled="oldTypeList.includes(1)">{{'购货商'}}</el-checkbox>
                    <el-checkbox :label="2" :disabled="oldTypeList.includes(2)">{{'供应商'}}</el-checkbox>
                    <el-checkbox :label="3" :disabled="oldTypeList.includes(3)">{{'运输公司'}}</el-checkbox>
                    <el-checkbox :label="4" :disabled="oldTypeList.includes(4)">{{'开证公司'}}</el-checkbox>
                    <el-checkbox :label="5" :disabled="oldTypeList.includes(5)">{{'仓库'}}</el-checkbox>
                    <el-checkbox :label="6" :disabled="oldTypeList.includes(6)">{{'海关'}}</el-checkbox>
                    <el-checkbox :label="9" :disabled="oldTypeList.includes(9)">{{'货代公司'}}</el-checkbox>
                </el-checkbox-group>
                <ul class="mrA" v-else>
                    <li v-for="item in formData.vc_typeName" :key="item" >{{item}}</li>
                </ul>
            </el-form-item>

            <el-form-item prop="i_isperson" label="公司类型" style="width: 350px" >
                <el-radio-group v-model="formData.i_isperson" v-if="canEdit">
                    <el-radio  :label="0">{{'企业'}}</el-radio>
                    <el-radio  :label="1">{{'个人'}}</el-radio>
                </el-radio-group>
                <div class="mrA" v-else>{{formData.i_isperson==0?'企业':'个人'}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_name" label="公司名称" style="width: 350px" required>
                <el-input v-if="canEdit" @change="changename" v-model="formData.vc_name" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_name}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_sname" label="公司简称" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.vc_sname" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_sname}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_enamefull" label="英文全称" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.vc_enamefull" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_enamefull}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_creditcode" label="机构代码" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.vc_creditcode" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_creditcode}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_legalname" label="法人" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.vc_legalname" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_legalname}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_money" label="注册资本" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.vc_money" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_money}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_establish" label="成立日期" style="width: 350px" >
                <el-date-picker v-if="canEdit" style="width: 190px" v-model="formData.vc_establish" size="mini" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" :placeholder="$t('form_select_date')"></el-date-picker>
                <div class="mrA" v-else>{{formData.vc_establish}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_businessterm" label="结束日期" style="width: 350px" >
                <el-date-picker v-if="canEdit" style="width: 190px" v-model="formData.vc_businessterm" size="mini" format="yyyy-MM-dd" value-format="yyyy-MM-dd" type="date" :placeholder="$t('form_select_date')"></el-date-picker>
                <div class="mrA" v-else>{{formData.vc_businessterm}}</div>
            </el-form-item>

            <el-form-item class="form-title" prop="szdq" label="所在地区" style="width: 380px" >
                <el-cascader v-if="canEdit&&cascadershow" v-model="formData.szdq" :props="dqprops" @change="handleChange" ref="cascaderAddr"></el-cascader>
<!--            <el-input v-if="canEdit" v-model="formData.szdq" size="mini" :placeholder="$t('form_please_enter')"></el-input>-->
                <div class="mrA" v-else>{{formData.vc_national+formData.vc_province+formData.vc_city}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_address" label="公司住所" style="width: 400px" >
                <el-input v-if="canEdit" v-model="formData.vc_address" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_address}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_pname" label="母公司" style="width: 350px" >
                <el-select v-if="canEdit" v-model="formData.i_pid" filterable remote reserve-keyword placeholder="请输入关键词" :remote-method="remoteMethod" :loading="loading" size="mini" style="margin-right: 9px;width:110px; ">
                    <el-option v-for="item in marcList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                </el-select>
                <div class="mrA" v-else>{{formData.vc_pname}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_gslist" label="下发公司" style="width: 380px;height: auto !important;min-height: 40px;max-height: 150px; overflow-y: auto;">
                <el-select v-if="canEdit" v-model="formData.vc_gslist" multiple  @remove-tag="handleRemoveTag"  @change="gjChange" size="mini" style="margin-right: 9px;" >
                    <el-option v-for="item in xfgsList" :key="item.i_id" :disabled="item.disabled" :label="item.vc_name" :value="item.i_id"></el-option>
                </el-select>
                <ul class="mrA" v-else>
                    <li v-for="item in formData.vc_gsname" :key="item" >{{item}}</li>
                </ul>
            </el-form-item>

            <!--<el-form-item class="form-title" prop="vc_eaddress" :label="$t('companyManageMD_english_address')" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_eaddress" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_eaddress}}</div>
            </el-form-item>-->
            <!--<el-form-item class="form-title" prop="i_bzid" :label="$t('companyManageMD_local_currency')" style="width: 350px" required>
                <el-select v-if="canEdit" v-model="formData.i_bzid"  @change="bzChange" size="mini" style="margin-right: 9px;width:110px; ">
                    <el-option v-for="item in bzList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                </el-select>
                <div class="mrA" v-else>{{formData.vc_bzname}}</div>
            </el-form-item>-->
            <!--<el-form-item class="form-title" prop="vc_spell" :label="$t('companyManageMD_abbreviation')" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.vc_spell" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_spell}}</div>
            </el-form-item>-->
            <!--<el-form-item class="form-title" prop="vc_kftel" :label="$t('companyManageMD_customer_service_hotline')" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_kftel" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_kftel}}</div>
            </el-form-item>-->
            <!--<el-form-item class="form-title" prop="vc_gstel" :label="$t('companyManageMD_company_office_number')" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.vc_gstel" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_gstel}}</div>
            </el-form-item>-->
            <!--<el-form-item class="form-title" prop="vc_site_page" :label="$t('companyManageMD_company_official_website')" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.vc_site_page" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_site_page}}</div>
            </el-form-item>-->
            <!--<el-form-item class="form-title" prop="vc_email_ht" :label="$t('companyManageMD_contract_email')" style="width: 350px" required>
                <el-input v-if="canEdit" v-model="formData.vc_email_ht" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_email_ht}}</div>
            </el-form-item>-->
            <!--<el-form-item class="form-title" prop="i_dsid" :label="$t('companyManageMD_e-commerce_id')" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.i_dsid" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.i_dsid}}</div>
            </el-form-item>-->
<!--            <el-form-item class="form-title" prop="i_fileid" label="邮件落款图标ID" style="width: 350px" >-->
<!--                <el-input v-if="canEdit" v-model="formData.i_fileid" size="mini" placeholder="请输入"></el-input>-->
<!--                <div class="mrA" v-else>{{formData.i_fileid}}</div>-->
<!--            </el-form-item>-->
<!--            <el-form-item class="form-title" prop="i_fileid_ht" label="内贸合同章ID" style="width: 350px" >-->
<!--                <el-input v-if="canEdit" v-model="formData.i_fileid_ht" size="mini" placeholder="请输入"></el-input>-->
<!--                <div class="mrA" v-else>{{formData.i_fileid_ht}}</div>-->
<!--            </el-form-item>-->
<!--            <el-form-item class="form-title" prop="i_fileid_htwx" label="外贸合同章ID" style="width: 350px" >-->
<!--                <el-input v-if="canEdit" v-model="formData.i_fileid_htwx" size="mini" placeholder="请输入"></el-input>-->
<!--                <div class="mrA" v-else>{{formData.i_fileid_htwx}}</div>-->
<!--            </el-form-item>-->
            <!--<el-form-item class="form-title" prop="i_type" :label="$t('companyManageMD_company_type')" style="width: 350px" required>
                <el-select v-if="canEdit" v-model="formData.i_type" size="mini" style="margin-right: 9px;width:110px; ">
                    <el-option v-for="item in lxList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                </el-select>
                <div class="mrA" v-else>{{lxList.find(l=>formData.i_type==l.i_id).vc_name}}</div>
            </el-form-item>-->
            <!--<el-form-item class="form-title" prop="i_pid" :label="$t('companyManageMD_group_company')" style="width: 350px">
                <el-select v-if="canEdit" v-model="formData.i_pid" filterable clearable :remote="true"
                           :remote-method="jtgssearch" @change="jtgsChange" size="mini" style="margin-right: 9px;width:110px; ">
                    <el-option v-for="item in jtgsList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
                </el-select>
                <div class="mrA" v-else>{{formData.vc_pname}}</div>
            </el-form-item>-->
            <!--<el-form-item class="form-title" prop="vc_plat" :label="$t('companyManageMD_attribution_system')" style="width: 350px" required>
                <el-radio-group v-model="formData.vc_plat" v-if="canEdit" :disabled="!!formData.i_pid">
                    <el-radio label="ghw">ghw</el-radio>
                    <el-radio label="havay">havay</el-radio>
                </el-radio-group>
                <div class="mrA" v-else>{{formData.vc_plat}}</div>
            </el-form-item>-->
            <!--<el-form-item prop="isuse" :label="$t('companyManageMD_enable_or_not')" style="width: 350px" required>
                <el-radio-group v-model="formData.isuse" v-if="canEdit">
                    <el-radio  :label="1">{{$t('form_correct')}}</el-radio>
                    <el-radio  :label="0">{{$t('form_deny')}}</el-radio>
                </el-radio-group>
                <div class="mrA" v-else>{{formData.isuse==1?$t('form_correct'):$t('form_deny')}}</div>
            </el-form-item>-->
            <!--<el-form-item prop="isuse" :label="$t('companyManageMD_is_it_compatible_with_ufida')" style="width: 350px" required>
                <el-radio-group v-model="formData.i_is_sync_to_yy" v-if="canEdit">
                    <el-radio  :label="1">{{$t('form_correct')}}</el-radio>
                    <el-radio  :label="0">{{$t('form_deny')}}</el-radio>
                </el-radio-group>
                <div class="mrA" v-else>{{formData.i_is_sync_to_yy==1?$t('form_correct'):$t('form_deny')}}</div>
            </el-form-item>-->
            <!--<el-form-item prop="isuse" :label="$t('companyManageMD_is_it_connected_to_the_north_and_south')" style="width: 350px" required>
                <el-radio-group v-model="formData.i_is_sync_to_nb" v-if="canEdit">
                    <el-radio  :label="1">{{$t('form_correct')}}</el-radio>
                    <el-radio  :label="0">{{$t('form_deny')}}</el-radio>
                </el-radio-group>
                <div class="mrA" v-else>{{formData.i_is_sync_to_nb==1?$t('form_correct'):$t('form_deny')}}</div>
            </el-form-item>-->
            <!--<el-form-item class="form-title" prop="vc_sign" :label="$t('companyManageMD_company_signature')" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.vc_sign" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_sign}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_fax" :label="$t('companyManageMD_fax')" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.vc_fax" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.vc_fax}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="i_khid" :label="$t('companyManageMD_associate_customer_id')" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.i_khid" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.i_khid}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="i_order" :label="$t('companyManageMD_serial_number')" style="width: 350px" >
                <el-input v-if="canEdit" v-model="formData.i_order" size="mini" :placeholder="$t('form_please_enter')"></el-input>
                <div class="mrA" v-else>{{formData.i_order}}</div>
            </el-form-item>-->

<!--            <el-form-item class="form-title" prop="title" label="本位币币种" style="width: 350px" required>-->
<!--                <el-input v-if="canEdit" v-model="formData.search" size="mini" placeholder="请输入"></el-input>-->
<!--                <div class="mrA" v-else>{{formData.search}}</div>-->
<!--            </el-form-item>-->
<!--            <el-form-item class="form-title" prop="i_mdid" label="主数据ID" style="width: 350px" required>-->
<!--                <el-input v-if="canEdit" v-model="formData.i_mdid" size="mini" placeholder="请输入"></el-input>-->
<!--                <div class="mrA" v-else>{{formData.i_mdid}}</div>-->
<!--            </el-form-item>-->
            <!--<el-form-item class="form-title" prop="i_fileid" :label="$t('companyManageMD_email_signature_icon_id')" style="width: 350px" >
                <div  id="uploadPhoto">
                    <div style="height:100px ;width: 80px; position: relative;" clsss="uploadBox" >
                        <input type="file" name="files" value="" id="uploadfile1" v-if="vc_fileid==''&&canEdit"
                               class="upload-input uploadfile1" @change="uploadFile($event,'yjlktb')">
                        <img src="@/assets/custom_pic.png" style="height:100px ;width: 80px" v-if="vc_fileid==''&&canEdit">
                        <img :src="vc_fileid" style="height:100px ;width: 80px" v-if="vc_fileid!=''" @click="handlePictureCardPreview(vc_fileid)">
                        <i class="el-icon-circle-close close" @click="closeFile('yjlktb')" v-if="vc_fileid!=''&&canEdit"></i>
                    </div>
                </div>
            </el-form-item>
            <el-form-item class="form-title" prop="i_fileid_ht" :label="$t('companyManageMD_internal_trade_contract_seal_id')" style="width: 350px" >
                <div  id="uploadPhoto">
                    <div style="height:100px ;width: 80px; position: relative;" clsss="uploadBox" >
                        <input type="file" name="files" value="" id="uploadfile1" v-if="vc_fileid_ht==''&&canEdit"
                               class="upload-input uploadfile1" @change="uploadFile($event,'nmhtz')">
                        <img src="@/assets/custom_pic.png" style="height:100px ;width: 80px" v-if="vc_fileid_ht==''&&canEdit">
                        <img :src="vc_fileid_ht" style="height:100px ;width: 80px" v-if="vc_fileid_ht!=''" @click="handlePictureCardPreview(vc_fileid_ht)">
                        <i class="el-icon-circle-close close" @click="closeFile('nmhtz')" v-if="vc_fileid_ht!=''&&canEdit"></i>
                    </div>
                </div>
            </el-form-item>
            <el-form-item class="form-title" prop="i_fileid_htwx" :label="$t('companyManageMD_foreign_trade_contract_seal_id')" style="width: 350px" >
                <div  id="uploadPhoto">
                    <div style="height:100px ;width: 80px; position: relative;" clsss="uploadBox" >
                        <input type="file" name="files" value="" id="uploadfile1" v-if="vc_fileid_htwx==''&&canEdit"
                               class="upload-input uploadfile1" @change="uploadFile($event,'wmhtz')">
                        <img src="@/assets/custom_pic.png" style="height:100px ;width: 80px" v-if="vc_fileid_htwx==''&&canEdit">
                        <img :src="vc_fileid_htwx" style="height:100px ;width: 80px" v-if="vc_fileid_htwx!=''" @click="handlePictureCardPreview(vc_fileid_htwx)">
                        <i class="el-icon-circle-close close" @click="closeFile('wmhtz')" v-if="vc_fileid_htwx!=''&&canEdit"></i>
                    </div>
                </div>
            </el-form-item>-->
            <el-form-item class="form-title" prop="vc_code_yongyou" label="用友code" style="width: 350px" >
                <div class="mrA" >{{formData.vc_code_yongyou}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_code_nanbei" label="南北code" style="width: 350px" >
                <div class="mrA" >{{formData.vc_code_nanbei}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="vc_lruname" :label="$t('form_input_person')" style="width: 350px" >
                <div class="mrA" >{{formData.vc_lruname}}</div>
            </el-form-item>
            <el-form-item class="form-title" prop="dt_createtime" :label="$t('form_enter_time')" style="width: 350px" >
                <div class="mrA" >{{formData.dt_createtime}}</div>
            </el-form-item>
        </el-form>
        <el-dialog :visible.sync="dialogVisible" append-to-body>
            <img width="100%" :src="dialogImageUrl" alt="">
        </el-dialog>
        <div  class="center">
                <el-button type="primary" @click="save('formData')" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">{{$t('button_save')}}</el-button>
<!--                <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">作废</el-button>-->
<!--                <el-button type="primary" @click="save" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="canEdit">启用</el-button>-->
                <el-button type="primary" @click="editForm" :disabled="disabled" :class="baseerp+'btn'" size="small" v-if="!canEdit">{{$t('button_edit')}}</el-button>
                <!--                <el-button type="warning" @click="flowSub" :disabled="disabled" size="small" v-if="canEdit">提交审批</el-button>-->
            <el-button @click="cancel" size="small">{{$t('button_cancel')}}</el-button>
        </div>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion,erpplatserver,file_root} from "@/utils/baseUrl";

    export default {
        name: "GsPage",
        components: {},
        props: {
            data:{
                type:Object,
                required: true,
                // default:()=>({})
            }
        },
        data() {
            return {
                cascadershow:false,
                loading:false,
                dqprops: {
                    label:'label',
                    value:'i_id',
                    lazy: true,
                    checkStrictly:true,
                    emitPath:true,
                    lazyLoad:this.lazyload
                    },
                tableHeight: 0,
                baseerp: '',
                marcList:[],
                xfgsList:[],
                formData:{
                    i_id:0,
                    i_mdid:0,
                    vc_type:'',
                    typeList:[],
                    i_isperson:0,
                    vc_gslist:[],
                    vc_name:'',
                    vc_sname:'',
                    vc_ename:'',
                    vc_enamefull:'',
                    vc_creditcode:'',
                    vc_legalname:'',
                    vc_money:'',
                    vc_establish:'',
                    vc_businessterm:'',
                    vc_address:'',
                    i_dygdruid:0,
                    i_pid:0,
                    vc_pname:'',
                    i_national:0,
                    vc_national:'',
                    i_province:0,
                    vc_province:'',
                    i_city:0,
                    vc_city:'',
                    szdq:[],
                    vc_typeName:[],
                    vc_gsname:[],
                },
                oldTypeList:[],
                vc_addtype:'',
                canEdit:false,
                disabled:false,
                gjList:[],
                bzList:[],
                lxList:[{i_id:0,vc_name:this.$t('companyManageMD_trading_companies')},{i_id:1,vc_name:this.$t('companyManageMD_entrusted_company')},{i_id:2,vc_name:this.$t('companyManageMD_trade+production_company_(including_filling_business)')},],
                rules:{
                    vc_name:[{required: true,message:'公司名称不能为空'}],
                    typeList:[{required: true,message:'客商类型不能为空'}],
                    szdq:[{required: true,message:'所在地区不能为空'}],
                    //vc_sname:[{required: true,message:this.$t('companyManageMD_the_company_abbreviation_cannot_be_empty')}],
                    //vc_ename:[{required: true,message:this.$t('companyManageMD_the_contract_identifier_cannot_be_empty')}],
                    //vc_enamefull:[{required: true,message:this.$t('companyManageMD_the_full_english_name_cannot_be_empty')}],
                    //i_national:[{required: true,message:this.$t('companyManageMD_the_country_cannot_be_empty')}],
                    //vc_address:[{required: true,message:this.$t('companyManageMD_the_address_cannot_be_empty')}],
                    //vc_eaddress:[{required: true,message:this.$t('companyManageMD_the_english_address_cannot_be_empty')}],
                    //vc_fr:[{required: true,message:this.$t('companyManageMD_the_legal_representative_cannot_be_left_blank')}],
                    //i_bzid:[{required: true,message:this.$t('companyManageMD_currency_cannot_be_empty')}],
                    //vc_creditcode:[{required: true,message:this.$t('companyManageMD_enterprise_code_cannot_be_empty')}],
                    //vc_kftel:[{required: true,message:this.$t('companyManageMD_customer_service_phone_number_cannot_be_empty')}],
                    //vc_email_ht:[{required: true,message:this.$t('companyManageMD_the_contract_email_cannot_be_empty')}],
                    //i_type:[{required: true,message:this.$t('companyManageMD_company_type_cannot_be_empty')}],
                    //vc_plat:[{required: true,message:this.$t('companyManageMD_group_affiliation_cannot_be_empty')}],
                    //isuse:[{required: true,message:this.$t('companyManageMD_whether_to_enable_cannot_be_empty')}],
                },
                // action:erpplatserver+'/system/uploadInvoice',
                dialogImageUrl:'',
                dialogVisible:false,
                jtgsList:[],
                vc_fileid_ht:'',
                vc_fileid:'',
                vc_fileid_htwx:'',
                dictList:[],
                fixedIds:[],
                checkkey:0,
            }
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
            //data:{
            //     handler(){
            //         if(this.data.i_id==0){
            //             this.canEdit=true
            //             this.getbzlist();
            //             this.getDqList();
            //             this.now=this.$DateTime.now();
            //             this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
            //             this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
            //             this.formData.i_lruid=sessionStorage.getItem("userid");//renid
            //         }else{
            //             this.formData=JSON.parse(JSON.stringify(this.data))
            //         }
            //         console.log(this.data,'handler',this.formData)
            //
            //     },
            //     immediate:true,
            //     deep:true
            // },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            this.now=this.$DateTime.now();
            this.$nextTick(() => {
                this.onResize();
            });
            if(this.data.i_id==0){
                this.canEdit=true;
                this.cascadershow=true;
                this.myRights();
                //this.getbzlist();
                //this.getDqList();
                //this.getDictList();
                this.getGroupCompanyList();
                this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                this.formData.i_lruid=sessionStorage.getItem("userid");//renid
            }else{
                //this.formData=JSON.parse(JSON.stringify(this.data));
                this.cascadershow=false;
                let data =this.data;
                if(data.i_pid && data.vc_pname){
                    this.marcList=[{i_id:data.i_pid,vc_name:data.vc_pname}]
                }
                if (data.vc_type && typeof data.vc_type === 'string') {
                    data.typeList = data.vc_type.split(',').filter(Boolean).map(item => {
                        return isNaN(Number(item)) ? item : Number(item);
                    });
                    this.oldTypeList=[...data.typeList]
                } else if (!data.vc_type) {
                    data.typeList = [];
                }
                this.$set(data, 'typeList', data.typeList);
                if (data.vc_gslist && typeof data.vc_gslist === 'string') {
                    data.vc_gslist = data.vc_gslist.split(',').filter(Boolean).map(item => {
                        return isNaN(Number(item)) ? item : Number(item);
                    });
                } else if (!data.vc_gslist) {
                    data.vc_gslist = [];
                }
                this.fixedIds=data.vc_gslist;
                const idPath = [
                    data.i_national,
                    data.i_province,
                    data.i_city
                ].map(item => Number(item)).filter(item => item!==0 && !isNaN(item));;
                //this.formData = data ;
                this.formData = Object.assign({}, this.formData, data);
                this.$set(this.formData, 'typeList', data.typeList);
                this.$set(this.formData, 'szdq', idPath);

                //console.log(this.formData.szdq,'szdq');
                this.$nextTick(()=>{
                    this.cascadershow=true;
                    this.checkkey++
                })

                this.vc_fileid=file_root+this.formData.vc_filepath;
                this.vc_fileid_ht=file_root+this.formData.vc_filepath_ht;
                this.vc_fileid_htwx=file_root+this.formData.vc_filepath_htwx;
            }
            // this.formData=JSON.parse(JSON.stringify(this.data));
            // console.log(this.data,'mounted',this.formData)


        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            /**
             * 封装的独立请求函数
             * @param node 当前点击的节点对象
             * @param resolve 必须调用的回调函数，用来返回数据
             */
            lazyload(node, resolve) {
                //console.log(node,resolve,'---')

                if (node.level === 0) {
                    /*let val={
                        value:0
                    }
                    setTimeout(() => {
                        this.getDqList(val,node.level,resolve);
                    }, 100)*/
                    setTimeout(() => {
                        this.getDqList({value:0},0,resolve);
                    }, 100)

                }
                if (node.level>=1&&node.level<=2){
                    const data = node.data || {}
                    this.getDqList(data,node.level,resolve);
                }
                if (node.level>2){
                    return resolve([])
                }
            },
            //国家
            async getDqList(dataObj,Level,resolve){
                if(typeof resolve !== 'function') return
                if (!dataObj) return resolve([]);
                let param = {
                    i_pid: dataObj.value !== undefined ? dataObj.value : 0,
                };
                let res=await API.getDqList(param);
                if ( res.code == 1 ){
                    let list = [];
                    if (res.data && res.data.length > 0) {
                        list = res.data.map(one => {
                            const name = one.vc_name;
                            const isCity = name && name.endsWith('市');

                            return {
                                label: name,
                                value: one.i_id,
                                i_id: one.i_id,
                                leaf: Level>= 2 || isCity
                            };
                        });
                    }
                    resolve(list);
                    //this.gjList=res.data;
                }else if (res.code == -2) {
                    resolve([]);
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    resolve([]);
                    this.$message.error(res.message);
                }
            },
            handleChange(value) {
                const checkedNodes = this.$refs['cascaderAddr'].getCheckedNodes();
                if (checkedNodes.length > 0) {
                    const node = checkedNodes[0];
                    const pathNodes = node.pathNodes;
                    this.formData.i_national = pathNodes[0]?.value || 0;
                    this.formData.vc_national   = pathNodes[0]?.label || '';
                    this.formData.i_province = pathNodes[1]?.value || 0;
                    this.formData.vc_province   = pathNodes[1]?.label || '';
                    this.formData.i_city     = pathNodes[2]?.value || 0;
                    this.formData.vc_city     = pathNodes[2]?.label || '';
                    console.log('当前完整路径信息：', this.formData);
                    this.formData.vc_address = this.formData.vc_national+this.formData.vc_province+this.formData.vc_city
                }
                this.$refs.cascaderAddr.dropDownVisible = false;
            },
            remoteMethod(query) {
                if (query !== '') {
                    this.loading = true;
                    setTimeout(() => {
                        this.loading = false;
                        this.getParentCustomers(query);
                        /*this.options = this.list.filter(item => {
                            return item.label.toLowerCase()
                                .indexOf(query.toLowerCase()) > -1;
                        });*/
                    }, 200);
                } else {
                    this.marcList = [];
                }
            },
            async getParentCustomers(query){
                let param={
                    vc_search:query,
                    vc_type: this.formData.vc_type,
                }
                let res= await API.getParentCustomers(param)
                if ( res.code ===1) {
                    let arr=[];
                    if(res.data){
                        let one={
                            vc_name:res.data.vc_name?res.data.vc_name:'',
                            i_id:res.data.i_id?res.data.i_id:0,
                        }
                        arr.push(one)
                    }
                    this.marcList=arr


                } else {
                    this.$error(res.message);
                }
            },
            changename(e){
                this.formData.vc_name=e;
                this.getCompanyList(e)
            },

            async getCompanyList(e){
                let param={
                    dt_starttime:'',
                    dt_endtime:'',
                    vc_type:'',
                    vc_name:e,
                    pageSize: 10,
                    currentPage:1,
                    i_gsid:'',
                };
                let res=await API.getCompanyList(param);
                if ( res.code == 1 ){
                    if(res.data.length>0){
                        this.cascadershow=false;
                        let map = {};
                        map = JSON.parse(JSON.stringify(res.data[0]));
                        if(map.i_pid && map.vc_pname){
                            this.marcList=[{i_id:map.i_pid,vc_name:map.vc_pname}]
                        }
                        if (map.vc_type && typeof map.vc_type === 'string') {
                            map.typeList = map.vc_type.split(',').filter(Boolean).map(item => {
                                return isNaN(Number(item)) ? item : Number(item);
                            });
                            this.oldTypeList=[...map.typeList]
                        } else if (!map.vc_type) {
                            map.typeList = [];
                        }
                        console.log('map.vc_type',map.vc_type)
                        if (map.vc_gslist && typeof map.vc_gslist === 'string') {
                            map.vc_gslist = map.vc_gslist.split(',').filter(Boolean).map(item => {
                                return isNaN(Number(item)) ? item : Number(item);
                            });
                        } else if (!map.vc_gslist) {
                            map.vc_gslist = [];
                        }
                        this.fixedIds=map.vc_gslist;
                        const idPath = [
                            map.i_national,
                            map.i_province,
                            map.i_city
                        ].map(item => Number(item)).filter(item => item!==0 && !isNaN(item));
                        this.formData = map;
                        this.$set(this.formData, 'szdq', idPath);
                        console.log(this.formData.szdq,'szdq');
                        this.$nextTick(()=>{
                            this.cascadershow=true;
                            this.getGroupCompanyList()
                        })
                    }


                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            jtgssearch(val){
                this.jtgs_search=val;
                this.getGroupCompanyList();
            },
            jtgsChange(){
                if(this.formData.i_pid){
                    this.formData.vc_plat=this.jtgsList.find(g=>g.i_id==this.formData.i_pid).vc_plat

                }

            },
            changetype(e){
                console.log(e,'e')
                const additem = e.filter(item => !this.oldTypeList.includes(item))
                this.vc_addtype = additem.join(',')
                //this.formData.typeList=e;
                //this.$set(this.formData, 'typeList', e);
                this.formData.vc_type=','+e.join(',')+',';
            },
            gjChange(g){
                console.log(g,'g')
                this.formData.vc_gslist=g;

                //this.formData.vc_national=this.gjList.find(g=>g.i_id==this.formData.i_national).vc_name
            },

            handleRemoveTag(val) {
                if (this.fixedIds.length>0&&this.fixedIds.includes(val)) {
                    this.$message.warning("该记录已下发，不可删除");
                    this.formData.vc_gslist.push(val);
                }
            },
            bzChange(){
                this.formData.vc_bzname=this.bzList.find(g=>g.i_id==this.formData.i_bzid).vc_name
            },
            handlePictureCardPreview(url) {
                this.dialogImageUrl = url;
                this.dialogVisible = true;
            },
            cancel(){
                this.$emit('close')
            },
            save(formName){
                this.$refs[formName].validate((valid)=>{
                    if(valid){
                        console.log(this.formData,'asd')
                        this.addCompany()
                    }else{
                        return false
                    }
                })
            },
            editForm(){
                this.cascadershow=false;
                this.canEdit=true
                this.getbzlist();
                this.getDqList();
                this.getDictList();

                this.getGroupCompanyList();
                this.$nextTick(()=>{
                    this.cascadershow=true;
                })
            },

            async myRights(){
                let param={};
                let res=await API.myRights(param);
                if ( res.code == 1 ){
                    this.typeList=res.data
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //币种
            async getbzlist(){
                let param={

                };
                let res=await API.getbzlist(param);
                if ( res.code == 1 ){
                    this.bzList=res.data.list;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },

            //集团公司
            async getGroupCompanyList(){
                let param={
                    vc_search:this.jtgs_search
                };
                let res=await API.getGroupCompanyList(param);
                if ( res.code == 1 ){
                    this.xfgsList=res.data;
//console.log
                    res.data.forEach(company => {
                        if (this.formData.vc_gslist.includes(company.i_id)) {
                            this.$set(company, 'disabled', true);
                        }
                    });
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //新增公司
            async addCompany(){
                this.disabled=true;
                this.formData.vc_gslist=this.formData.vc_gslist.join(',')
                this.formData.dt_createtime=this.now.toFormat('yyyy-MM-dd');//当前时间
                this.formData.vc_lruname=sessionStorage.getItem("lruname");//ren
                this.formData.i_lruid=sessionStorage.getItem("userid");//renid
                this.formData.vc_addtype=this.vc_addtype;
                this.formData.i_iscmainland= this.formData.i_national==5175?1:0;
                let param=JSON.parse(JSON.stringify(this.formData));
                delete param.typeList;
                delete param.vc_typeName;
                delete param.vc_gsname;
                delete param.szdq;
                let res=await API.addCompany(param);
                if ( res.code == 1 ){
                    this.$message.success(res.message)
                    this.canEdit=false
                    this.$emit('close','save')
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                    // this.canEdit=false
                    this.disabled=false;

                }
            },
            closeFile(filetype){
                if(filetype=='nmhtz'){
                    this.vc_fileid_ht=''
                    this.formData.i_fileid_ht=null
                }else if(filetype=='wmhtz'){
                    this.vc_fileid_htwx=''
                    this.formData.i_fileid_htwx=null
                }else if(filetype=='yjlktb'){
                    this. vc_fileid=''
                    this.formData.i_fileid=null
                }
            },
            //单位接口(ji单位)
            async getDictList(){
                let param={
                    vc_type:'unit',
                };
                let res=await API.getDictList(param);
                if (res.code==1){
                    this.dictList=res.data;
                    // this.jzdwList=res.data;
                    //console.log(this.dictList,"this.dictList")
                }
            },
            async uploadFile(e,filetype) {
                if(filetype=='nmhtz'){
                    let that = this;
                    let i = 0;
                    let $files = e.target.files[0];
                    let fileName = $files.name;
                    let type = $files.type;
                    var list = {
                        "image/jpeg": true,
                        "image/png": true,
                        "image/jpg": true,
                        "image/bmp": true,
                        "application/pdf": true
                    };
                    let result = list[type];

                    if ($files) {
                        that.fileName = $files.name;
                        that.fileType = $files.type;
                        that.fileUrl = window.URL.createObjectURL(e.target.files[0]);
                    } else {
                        that.fileName = "";
                        that.fileType = "";
                        that.fileUrl = "";
                    }
                    if (that.fileName) {
                        var param = {
                            // "file": fileId,
                            // "fileName": that.fileName,
                            // "IDtype": "",
                            // "type": 1,
                            "style": "kh",
                            "files": $files,
                            //"token":sessionStorage.getItem("token"),
                            //"app": "dsmanage",
                            "vc_app": "kh",
                            "i_appid": 0,
                            // "version": "1.0",
                            // "i_uid": sessionStorage.getItem("userid"),
                            "vc_lruname": sessionStorage.getItem("userid"),
                            "i_lruid": sessionStorage.getItem("userid"),
                            // "i_mid": this.mid
                        };
                        let FD = new FormData();
                        for (let key in param) {
                            FD.append(key, param[key])
                        }
                        let res = await API.uploadFile(param);
                        if (res.code == 1) {
                            // if(filetype=='nmhtz'){
                            that.vc_fileid_ht = file_root + res.data[0].vc_path
                            that.formData.i_fileid_ht = res.data[0].i_id
//console.log
                        } else if (res.code == -2) {
                            that.$router.push('/login');
                            that.$message.error(res.message);
                        } else {
                            that.$message.error(res.message);
                        }
                    }
                }else if(filetype=='wmhtz'){
                    let that = this;
                    let i = 0;
                    let $files = e.target.files[0];
                    let fileName = $files.name;
                    let type = $files.type;
                    var list = {
                        "image/jpeg": true,
                        "image/png": true,
                        "image/jpg": true,
                        "image/bmp": true,
                        "application/pdf": true
                    };
                    let result = list[type];

                    if ($files) {
                        that.fileName = $files.name;
                        that.fileType = $files.type;
                        that.fileUrl = window.URL.createObjectURL(e.target.files[0]);
                    } else {
                        that.fileName = "";
                        that.fileType = "";
                        that.fileUrl = "";
                    }
                    if (that.fileName) {
                        var param = {
                            // "file": fileId,
                            // "fileName": that.fileName,
                            // "IDtype": "",
                            // "type": 1,
                            "style": "kh",
                            "files": $files,
                            //"token":sessionStorage.getItem("token"),
                            //"app": "dsmanage",
                            "vc_app": "kh",
                            "i_appid": 0,
                            // "version": "1.0",
                            // "i_uid": sessionStorage.getItem("userid"),
                            "vc_lruname": sessionStorage.getItem("userid"),
                            "i_lruid": sessionStorage.getItem("userid"),
                            // "i_mid": this.mid
                        };

                        let FD = new FormData();
                        for (let key in param) {
                            FD.append(key, param[key])
                        }
                        let res = await API.uploadFile(param);
                        if (res.code == 1) {
                            that.vc_fileid_htwx = file_root + res.data[0].vc_path
                            that.formData.i_fileid_htwx = res.data[0].i_id
                            console.log(this.vc_fileid_htwx,'vc_fileid_htwx')
                        } else if (res.code == -2) {
                            that.$router.push('/login');
                            that.$message.error(res.message);
                        } else {
                            that.$message.error(res.message);
                        }
                    }
                }else if(filetype=='yjlktb'){
                    let that = this;
                    let i = 0;
                    let $files = e.target.files[0];
                    let fileName = $files.name;
                    let type = $files.type;
                    var list = {
                        "image/jpeg": true,
                        "image/png": true,
                        "image/jpg": true,
                        "image/bmp": true,
                        "application/pdf": true
                    };
                    let result = list[type];

                    if ($files) {
                        that.fileName = $files.name;
                        that.fileType = $files.type;
                        that.fileUrl = window.URL.createObjectURL(e.target.files[0]);
                    } else {
                        that.fileName = "";
                        that.fileType = "";
                        that.fileUrl = "";
                    }
                    if (that.fileName) {
                        var param = {
                            // "file": fileId,
                            // "fileName": that.fileName,
                            // "IDtype": "",
                            // "type": 1,
                            "style": "kh",
                            "files": $files,
                            //"token":sessionStorage.getItem("token"),
                            //"app": "dsmanage",
                            "vc_app": "kh",
                            "i_appid": 0,
                            // "version": "1.0",
                            // "i_uid": sessionStorage.getItem("userid"),
                            "vc_lruname":  sessionStorage.getItem("userid"),
                            "i_lruid": sessionStorage.getItem("userid"),
                            // "i_mid": this.mid
                        };

                        let FD = new FormData();
                        for (let key in param) {
                            FD.append(key, param[key])
                        }
                        let res = await API.uploadFile(param);
                        if (res.code == 1) {
                            that.vc_fileid=file_root+res.data[0].vc_path
                            that.formData.i_fileid=res.data[0].i_id
                            console.log(this.vc_fileid,'vc_fileid')
                        } else if (res.code == -2) {
                            that.$router.push('/login');
                            that.$message.error(res.message);
                        } else {
                            that.$message.error(res.message);
                        }
                    }
                }
                // this.$forceUpdate()
            },
        },
    }
</script>

<style lang="scss" scoped>
    .no-delete-select /deep/ .el-tag__close.el-icon-close {
        display: none !important;
    }
    .center{
        text-align: center;
    }
    /deep/{
        .el-form-item__content{
            width: calc(100% - 145px);
        }
        .el-select{
            margin-right: 0 !important;
            width: 100% !important;
        }
    }
    .upload-input {
        position: absolute;
        opacity: 0;
        width: 80px;
        height: 100px;
    }
    .close{
        position: absolute;
        top: -5px;
        right: -5px;
    }
</style>